import Heading from '@pelckmans/elementis/components/heading';
import Paragraph from '@pelckmans/elementis/components/paragraph';
import { Cell } from '@pelckmans/elementis/components/table';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ImportMembersContext } from '../contexts/ImportMembersContext';
import MemberDataRow, { ACTIONS_COLUMN, COLUMN_ORDER, SELECTION_COLUMN } from './MemberDataRow';
import { linkColumnOptions } from './SelectFieldToLink';

const TRANSLATION_KEY = 'PAGES.MY_GROUPS.MODALS.IMPORT_MEMBERS.VALIDATE_MEMBERS_DATA';

export default function ValidateMembersData() {
  const { t } = useTranslation();

  const { columnMappingByLinkedOption, toBeAddedMembers, selection, setSelection } = useContext(ImportMembersContext);

  function isAllSelected() {
    return toBeAddedMembers.length > 0 && toBeAddedMembers.length === selection.size;
  }

  function handleSelectAll() {
    setSelection(() => (isAllSelected() ? new Set<number>() : new Set(toBeAddedMembers.map((_, index) => index))));
  }

  return (
    <div className="validate-members-data">
      <div className="modal-content-text">
        <Heading level={4} removeSpacing="top">
          {t(`${TRANSLATION_KEY}.TITLE`)}
        </Heading>
        <Paragraph size="md" removeSpacing>
          {t(`${TRANSLATION_KEY}.DESCRIPTION`)}
        </Paragraph>
      </div>
      <div className="preview">
        <div className="subtexts">
          <Paragraph size="sm" removeSpacing>
            <b>{t(`${TRANSLATION_KEY}.TABLE.DESCRIPTION`)}</b>
          </Paragraph>
        </div>
        <div className="table-container scroll-table-container">
          <table className="table">
            <thead>
              <tr>
                {COLUMN_ORDER.map(columnOption => {
                  const key = `header-${columnOption}`;

                  if (columnOption === SELECTION_COLUMN) {
                    return (
                      <Cell.HeaderSelection
                        checkboxProps={{ checked: isAllSelected() ? true : undefined, onChange: handleSelectAll }}
                        key={key}
                        sticky
                      />
                    );
                  }

                  if (columnOption === ACTIONS_COLUMN) {
                    return <Cell.HeaderEmpty key={key} sticky />;
                  }

                  const columnIndex = columnMappingByLinkedOption?.[columnOption];
                  const showUsernameTooltip = columnIndex === undefined && columnOption === linkColumnOptions.USERNAME;

                  const emailColumn = columnOption === linkColumnOptions.EMAIL;

                  if (showUsernameTooltip) {
                    return (
                      <Cell.HeaderText
                        key={key}
                        title={t(`${TRANSLATION_KEY}.COLUMNS.${columnOption}`)}
                        info
                        tooltipProps={{
                          truncation: 'default',
                          children: t(`${TRANSLATION_KEY}.TABLE.TOOLTIP_USERNAME`),
                        }}
                        minWidth="sm"
                        maxWidth="sm"
                        sticky
                      />
                    );
                  }

                  return (
                    <Cell.HeaderText
                      key={key}
                      title={t(`${TRANSLATION_KEY}.COLUMNS.${columnOption}`)}
                      minWidth={emailColumn ? 'md' : 'sm'}
                      maxWidth={emailColumn ? 'md' : 'sm'}
                      sticky
                    />
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {toBeAddedMembers.map((member, index) => (
                <MemberDataRow key={`row-${index}`} rowIndex={index} member={member} />
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
